import { createVNode as o, mergeProps as a } from "vue";
import i from "../node_modules/@pf-ui/pf-icon-svg/es/asn/CloseCircleFilledStandard.js";
import d from "../components/PfIcon.js";
const r = (e, l) => {
  const t = {
    ...e,
    ...l.attrs
  };
  return o(d, a(t, {
    icon: i
  }), null);
};
r.displayName = "CloseCircleFilledStandard";
r.inheritAttrs = !1;
export {
  r as default
};
